"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TicketMessage = require("./TicketMessage.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WatchMessage = function WatchMessage(_ref) {
  var ticketsLink = _ref.ticketsLink,
      badgeUrl = _ref.badgeUrl,
      actionUrl = _ref.actionUrl;
  return /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicket, {
    id: "popup-ticket"
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTwoCol, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColLeft, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "Have a ticket?"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "Please enter your email associated with the ticket order or Multipass below. If you're not sure, please check an email from the event org team containing direct access link."), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketForm, {
    action: actionUrl,
    method: "get",
    target: "_blank",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketField, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketInput, {
    type: "email",
    name: "email",
    placeholder: "Your email"
  }), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketSubmitButton, {
    type: "submit"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Unlock"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketArrowSvg, null, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "img/sprite.svg#icon-arrow-right"
  })))))), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketColRight, null, /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketTitle, null, "Claim free limited access"), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketDesc, null, "Access the conference stream page with free partner perks, workshop opportunities and check your email for a possibility to upgrade to full ticket by sharing your personalized badge."), /*#__PURE__*/_react.default.createElement(_TicketMessage.PopTicketButtonWithBorder, {
    href: badgeUrl,
    target: "blank_"
  }, "Claim access"))));
};

var _default = WatchMessage;
exports.default = _default;